export const fileTypesEnum = { photos: 'Photos', videos: 'Videos', files: 'Files', links: 'Links' };
